import { connect } from 'react-redux';
import {
  hideFaceCheckModal,
  processFaceVideo,
  setError,
} from '../../../../ReduxStorage/IdentitySession/dispatchers';
import { Dispatch } from '../../../../ReduxStorage/thunk';
import { FaceCheck } from './component';
import { ReduxState } from '../../../../ReduxStorage/state';
import {
  selectShowFaceCheckModal,
  selectLoading,
  selectError,
} from '../../../../ReduxStorage/IdentitySession/selectors';

export const ConnectedFaceCheck = connect(
  (state: ReduxState) => ({
    showFaceCheckModal: selectShowFaceCheckModal(state),
    loading: selectLoading(state),
    error: selectError(state),
  }),
  (dispatch: Dispatch) => ({
    hideFaceCheckModal: () => dispatch(hideFaceCheckModal),
    processFaceVideo: (blob: Blob) => dispatch(processFaceVideo(blob)),
    setError: (message: string | null) => dispatch(setError(message)),
  })
)(FaceCheck);
